import Api from '@/api/config/_api_config.js'

export default{

    log_user(data){
        const promise = Api().post('/login',data)
        return promise.then((response) => response.data)
    }
}